import React, { Component } from "react";

import {
  CCard,
  CCardHeader,
  CCardBody,
  CButton,
  CLabel,
  CFormGroup
} from "@coreui/react";
import { connect } from "react-redux";
import { toastr } from "react-redux-toastr";
import { bindActionCreators } from "redux";

import { logout } from "../../../../actions/baseActions";
import { setObj } from "../../../../actions/noteActions";
import Breadcrumb from "../../../../components/Breadcrumb";
import Loading from "../../../../components/Loading";
import ProtectedRoute from "../../../../components/ProtectedRoute";
import { Input } from "../../../../components/SlateComponents";
import URL from "../../../../config/api";
import axios from "../../../../config/axios";

class FaqCreate extends Component {
  constructor(props) {
    super(props);

    this.state = {
      edit: false,
      // user: {},
      loading: false,
      answer: [{ type: "paragraph", children: [{ text: "" }] }],
      question: [{ type: "paragraph", children: [{ text: "" }] }]
    };

    this.enviar = this.enviar.bind(this);
    this.atualizar = this.atualizar.bind(this);
    this.error = this.error.bind(this);
    this.formRef = React.createRef();
  }

  error(response) {
    if (response === "Unauthorized") {
      this.props.logout(this.props.user.token);
    } else {
      toastr.error("Falha", response);
    }
  }

  // eslint-disable-next-line camelcase
  UNSAFE_componentWillMount() {
    this.props.setObj(16, this.props.currentRoute, this.props.currentRoute);

    const idUser = this.props.match.params.id;

    if (idUser) {
      this.setState({ loading: true, id: idUser }, () => {
        axios
          .get(`${URL.api}helpdesk/faq/singleView/${idUser}`, {
            headers: { authorization: `Bearer ${this.props.user.token}` }
          })
          .then(
            resp => {
              this.setState({
                answer: JSON.parse(resp.data.data.answer),
                question: JSON.parse(resp.data.data.question),
                edit: true,
                loading: false
              });
            },
            error => {
              this.error(error.response.statusText);
            }
          );
      });
    }
  }

  enviar() {
    const obj = {
      question: JSON.stringify(this.state.question),
      answer: JSON.stringify(this.state.answer)
    };

    axios
      .post(`${URL.api}helpdesk/faq/insert`, obj, {
        headers: { authorization: `Bearer ${this.props.user.token}` }
      })
      .then(resp => {
        this.props.history.push("/helpdesk/faq/list");
      });
  }

  atualizar() {
    const obj = {
      id: this.state.id,
      question: JSON.stringify(this.state.question),
      answer: JSON.stringify(this.state.answer)
    };

    axios
      .post(`${URL.api}helpdesk/faq/update/${this.state.id}`, obj, {
        headers: { authorization: `Bearer ${this.props.user.token}` }
      })
      .then(resp => {
        this.props.history.push("/helpdesk/faq/list");
      });
  }

  render() {
    return (
      <>
        <Breadcrumb
          current={this.props.currentRoute}
          items={[{ path: "/helpdesk/faq/list", to: "/helpdesk/faq/list" }]}
        />
        {this.state.loading ? (
          <Loading />
        ) : (
          <CCard>
            <CCardHeader className="d-flex align-items-center">
              <div
                style={{ display: "flex", flexDirection: "column", flex: 1 }}
              >
                <h4 className="card-title mb-1">
                  {this.state.edit ? "Editar FAQ" : "Criar FAQ"}
                </h4>
                <div className="small text-muted">
                  {this.state.edit ? "Edite o FAQ" : "Crie um novo FAQ"}
                </div>
              </div>
              <CButton
                color="primary"
                onClick={() =>
                  this.state.edit ? this.atualizar() : this.enviar()
                }
              >
                <i className="fa fa-cloud-upload mr-2"></i>Salvar
              </CButton>
            </CCardHeader>
            <CCardBody>
              <CFormGroup>
                <CLabel>Pergunta</CLabel>
                <Input
                  value={this.state.question}
                  onChange={value => this.setState({ question: value })}
                  placeholder="Pergunta"
                  hideMenu
                />
              </CFormGroup>
              <CFormGroup className="mb-0">
                <CLabel>Resposta</CLabel>
                <Input
                  value={this.state.answer}
                  onChange={value => this.setState({ answer: value })}
                  placeholder="Resposta"
                />
              </CFormGroup>
              {/* <Form2
                avatar={true}
                fields={fields}
                history={this.props.history}
                onSubmit={this.state.edit ? this.atualizar : this.enviar}
                initialValues={this.state.faq}
                edit={this.state.edit}
                ref={this.formRef}
              /> */}
            </CCardBody>
          </CCard>
        )}
        <ProtectedRoute routeId={this.props.currentRoute} />
      </>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user,
  general: state.general,
  profile: state.profile
});

const mapDispatchToProps = dispatch =>
  bindActionCreators({ logout, setObj }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(FaqCreate);
